import { Button } from "@faire/slate/components/button";
import {
  BaseModal,
  BaseModalBody,
  BaseModalFooter,
  BaseModalHeader,
} from "@faire/slate/components/modal/base";
import { tsv } from "@faire/slate/lib/tsv";

interface UnfavoriteConfirmationModalProps {
  imageUrl: string;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const UnfavoriteConfirmationModal: React.FC<
  UnfavoriteConfirmationModalProps
> = ({ imageUrl, open, onCancel, onConfirm }) => (
  <BaseModal
    data-test-id="unfavorite-confirmation-modal"
    onClose={onCancel}
    open={open}
    size="small"
  >
    <BaseModalHeader title="Unfavorite product?" />
    <BaseModalBody>
      <div className={modalBodyStyle.cls()}>
        <div className={productImageStyle.cls()}>
          <img alt="" className="size-full object-cover" src={imageUrl} />
        </div>
        <p className="type-fs-paragraph w-full">
          Unfavoriting this product will also remove it from all collections.
        </p>
      </div>
    </BaseModalBody>
    <BaseModalFooter>
      <Button onClick={onConfirm}>Unfavorite</Button>
      <Button onClick={onCancel} variant="secondary">
        Cancel
      </Button>
    </BaseModalFooter>
  </BaseModal>
);

const modalBodyStyle = tsv({
  base: [
    "flex w-full flex-col items-center",
    "gap-(--slate-spacing-group-large)",
  ],
});

const productImageStyle = tsv({
  base: [
    "border-fs-border-muted bg-fs-surface-tertiary",
    "rounded-fs-component-default shadow-elevation-low size-20 overflow-hidden border",
  ],
});
